import { omit } from 'lodash';
import { PageRecipientBasicModel } from '@/helpers/entities/models/PageRecipientBasicModel';
import { InquiryProductBasicModel } from '@/helpers/entities/models/InquiryProductBasicModel';
export class InquiryRequestModel {
    constructor(payload) {
        const params = omit(payload, 'pageRecipient', 'inquiryProduct');
        Object.assign(this, params);
        this.pageRecipient = new PageRecipientBasicModel(payload.pageRecipient);
        this.inquiryProduct = new InquiryProductBasicModel(payload.inquiryProduct);
    }
}
